"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsDateToDateObject = exports.mergeMetadata = exports.streamingEndpoint = exports.unaryEndpoint = exports.spxSetDefaultTransport = exports.throwConversionError = exports.wrap = exports.unwrap = exports.convertRecordFromJSPBMap = exports.recordFromJSPBMap = exports.emptyObjectToEmptyPb = exports.emptyPbToEmptyObject = exports.dateObjectToDate = exports.dateToDateObject = exports.momentToTimestamp = exports.timestampToMoment = exports.identity = exports.GrpcError = void 0;
var tslib_1 = require("tslib");
var grpc_web_1 = require("@improbable-eng/grpc-web");
var timestamp_pb_1 = require("google-protobuf/google/protobuf/timestamp_pb");
var empty_pb_1 = require("google-protobuf/google/protobuf/empty_pb");
var utils_1 = require("./utils");
var moment = tslib_1.__importStar(require("moment"));
var redux_saga_1 = require("redux-saga");
var date_pb_1 = require("../lib/generated/google/type/date_pb");
/**
 * An Error type that can give the message and status code of a grpc error.
 *
 * @export
 * @class GrpcError
 * @extends {Error}
 */
var GrpcError = /** @class */ (function (_super) {
    tslib_1.__extends(GrpcError, _super);
    function GrpcError(message, code, metadata) {
        var _this = _super.call(this, message) || this;
        _this.code = code;
        _this.metadata = metadata;
        return _this;
    }
    return GrpcError;
}(Error));
exports.GrpcError = GrpcError;
/** identity is the identity function, used when something expects a conversion
 * function but there's no actual conversion to perform.
 */
function identity(msg) {
    return msg;
}
exports.identity = identity;
/**
 * timestampToMoment converts a timestamp to a moment.Moment (or undefined to
 * undefined).
 */
exports.timestampToMoment = function (ts) {
    return ts && moment.unix(ts.getSeconds() + ts.getNanos() / 1000000000).utc();
};
/**
 * momentToTimestamp Converts a moment.Moment to a Timestamp.
 */
exports.momentToTimestamp = function (m) {
    var ts = new timestamp_pb_1.Timestamp();
    ts.fromDate(m.toDate());
    return ts;
};
exports.dateToDateObject = function (d) {
    return d ? d.toObject() : { year: 0, month: 0, day: 0 };
};
exports.dateObjectToDate = function (d) {
    var dt = new date_pb_1.Date();
    dt.setYear(d.year);
    dt.setMonth(d.month);
    dt.setDay(d.day);
    return dt;
};
exports.emptyPbToEmptyObject = function (e) { return e && {}; };
exports.emptyObjectToEmptyPb = function (o) { return new empty_pb_1.Empty(); };
/**
 * convertRecordFromJSPBMap converts a jspb.Map to a Record.
 */
function recordFromJSPBMap(map) {
    var obj = {};
    map.forEach(function (value, key) {
        obj[key] = value;
    });
    return obj;
}
exports.recordFromJSPBMap = recordFromJSPBMap;
/**
 * convertRecordFromJSPBMap converts a jspb.Map to a Record by converting each
 * element of the map via the convert function.
 */
function convertRecordFromJSPBMap(map, convert) {
    var obj = {};
    map.forEach(function (value, key) {
        obj[key] = convert(value);
    });
    return obj;
}
exports.convertRecordFromJSPBMap = convertRecordFromJSPBMap;
/**
 * unwrap extracts the value from a well-known wrapper type,
 * or returns undefined if it was passed undefined.
 */
function unwrap(wrapperValue) {
    return wrapperValue ? wrapperValue.getValue() : undefined;
}
exports.unwrap = unwrap;
/**
 * wrap instantiates a well-known wrapper type and sets its value,
 * or returns undefined if it was passed undefined.
 */
function wrap(wrapperConstructor) {
    return function (val) {
        if (val === undefined) {
            return undefined;
        }
        var wrapper = new wrapperConstructor();
        wrapper.setValue(val);
        return wrapper;
    };
}
exports.wrap = wrap;
/**
 * throwConversionError is called when a field has the option
 * (sparx.api.typescript.required) but a received protobuf message hasn't set
 * the field. It throws a descriptive TypeError with an extra rawMessage field
 * to aid debugging.
 */
function throwConversionError(messageName, fieldName, rawMessage) {
    var e = new TypeError("Field " + fieldName + " on " + messageName + " has (sparx.api.typescript.required) option but is unset in received message");
    // Add the raw message to the error object for developer convenience
    e.rawMessage = rawMessage;
    throw e;
}
exports.throwConversionError = throwConversionError;
/**
 * spxSetDefaultTransport wraps the grpc method for setting the default transport.
 * This allows the client to set the default transport.
 *
 * If the client directly called grpc.setDefaultTransport this would take effect in a
 * different 'instance' of grpc, hence not affecting any of the calls made
 * through unaryEndpoint() or streamingEndpoint()
 *
 * This previously worked because tpclient's grpc instance was resolved by node to the same grpc instance,
 * but with pnpm's stricter resolution, this no longer works.
 */
exports.spxSetDefaultTransport = function (t) {
    return grpc_web_1.grpc.setDefaultTransport(t);
};
// Posts a message that can be picked up by the SafetyCulture GRPCweb dev tools.
// https://github.com/SafetyCulture/grpc-web-devtools
var updateDevTools = function (name, req, resp, err) {
    var msg = {
        source: '__GRPCWEB_DEVTOOLS__',
        type: '__GRPCWEB_DEVTOOLS__',
        methodType: 'unary',
        method: name,
        request: req.toObject(),
        response: resp === null || resp === void 0 ? void 0 : resp.toObject(),
        error: err
    };
    window.postMessage(msg, '*');
};
/**
 * unaryEndpoint wraps a gRPC-Web service method descriptor and some type
 * conversion functions into a function that takes a 'clean' request and
 * returns a Promise of a 'clean' response. This allows callers to never touch
 * the raw protoc-generated protobuf types.
 */
function unaryEndpoint(methodDescriptor, convertRequestToRaw, convertResponseToClean) {
    var _this = this;
    return function (host, req, meta) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var metadata, _a;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = meta;
                    if (!_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, meta()];
                case 1:
                    _a = (_b.sent());
                    _b.label = 2;
                case 2:
                    metadata = _a;
                    return [4 /*yield*/, new Promise(function (resolve, reject) {
                            var request = convertRequestToRaw(req);
                            var name = methodDescriptor.service.serviceName + "." + methodDescriptor.methodName;
                            grpc_web_1.grpc.unary(methodDescriptor, {
                                host: host,
                                metadata: metadata,
                                onEnd: function (res) {
                                    if (res.status === 0 && res.message) {
                                        try {
                                            resolve(convertResponseToClean(res.message));
                                        }
                                        catch (e) {
                                            reject(utils_1.ensureError(e));
                                        }
                                        try {
                                            updateDevTools(name, request, res.message);
                                        }
                                        catch (_a) {
                                            // Do nothing
                                        }
                                    }
                                    else {
                                        reject(new GrpcError(res.statusMessage, res.status, res.trailers));
                                        try {
                                            updateDevTools(name, request, undefined, {
                                                message: res.statusMessage,
                                                code: res.status,
                                                codeMessage: grpc_web_1.grpc.Code[res.status],
                                                metadata: res.trailers
                                            });
                                        }
                                        catch (_b) {
                                            // Do nothing
                                        }
                                    }
                                },
                                request: request
                            });
                        })];
                case 3: return [2 /*return*/, _b.sent()];
            }
        });
    }); };
}
exports.unaryEndpoint = unaryEndpoint;
/**
 * streamingEndpoint wraps a gRPC-Web service method descriptor and some type
 * conversion functions into a function that takes a 'clean' request and
 * returns an EventChannel of 'clean' responses (or Errors, or END if the gRPC
 * stream is closed). This allows callers to never touch the raw
 * protoc-generated protobuf types.
 */
function streamingEndpoint(methodDescriptor, convertRequestToRaw, convertResponseToClean) {
    var _this = this;
    return function (host, req, meta) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var metadata, _a;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = meta;
                    if (!_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, meta()];
                case 1:
                    _a = (_b.sent());
                    _b.label = 2;
                case 2:
                    metadata = _a;
                    return [2 /*return*/, redux_saga_1.eventChannel(function (emitter) {
                            var grpcRequest = grpc_web_1.grpc.invoke(methodDescriptor, {
                                host: host,
                                metadata: metadata,
                                onEnd: function (status, message, trailers) {
                                    if (status !== grpc_web_1.grpc.Code.OK) {
                                        emitter(new GrpcError(message, status));
                                    }
                                    emitter(redux_saga_1.END);
                                },
                                onMessage: function (msg) {
                                    try {
                                        emitter(convertResponseToClean(msg));
                                    }
                                    catch (e) {
                                        emitter(utils_1.ensureError(e));
                                    }
                                },
                                request: convertRequestToRaw(req)
                            });
                            return function () {
                                grpcRequest.close();
                            };
                        })];
            }
        });
    }); };
}
exports.streamingEndpoint = streamingEndpoint;
exports.mergeMetadata = function (m1, m2) {
    if (m1 === undefined) {
        return m2;
    }
    if (m2 === undefined) {
        return m1;
    }
    return function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var meta;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, m1()];
                case 1:
                    meta = _a.sent();
                    return [4 /*yield*/, m2()];
                case 2:
                    (_a.sent()).forEach(function (key, vals) {
                        meta.append(key, vals);
                    });
                    return [2 /*return*/, meta];
            }
        });
    }); };
};
exports.jsDateToDateObject = function (d) {
    return {
        year: d.getFullYear(),
        month: d.getMonth() + 1,
        day: d.getDate()
    };
};
